import { SET_MODULES, RESET_MODULES } from 'store/types/module';

const initModules = {
  modules: null
};

export const moduleReducer = (state = initModules, action) => {
  switch (action.type) {
    case SET_MODULES:
      return {
        ...state,
        modules: action.payload
      };
    case RESET_MODULES:
      return { ...initModules };
    default:
      return state;
  }
};
